import { IntlProvider } from 'react-intl';
import moment from 'moment';
import axios from 'axios';
import * as actionTypes from 'actions/actionTypes';
import store from 'router/store';
import { testLocalStorageSupport } from 'utils/localRepository';

const getIntl = () => store.getState().intl;

const isLocalStorageSupported = testLocalStorageSupport();

export function getLanguage(country) {
  const countryCode = country || COUNTRY;
  const lang = getIntl().locale;
  if (!['et', 'ru', 'lv', 'fi', 'es', 'lt'].includes(lang)) {
    if (countryCode === 'LV') {
      return 'lv';
    } if (countryCode === 'FI') {
      return 'fi';
    } if (countryCode === 'MX' || countryCode === 'ES') {
      return 'es';
    } if (countryCode === 'PL') {
      return 'pl';
    } if (countryCode === 'AU') {
      return 'en';
    } if (countryCode === 'LT') {
      return 'lt';
    } if (countryCode === 'CZ') {
      return 'cs';
    }
    return 'et';
  }
  return lang;
}

export function changeLanguage(lang) {
  if (isLocalStorageSupported) {
    localStorage.setItem(`${COUNTRY}.credit24.language`, lang);
  }
  if (lang !== 'en') {
    moment.locale(lang);
  }
  return {
    type: actionTypes.CHANGE_LANGUAGE,
    data: lang,
  };
}

export function getMessageFromState(id) {
  const { intl: { locale, messages } } = store.getState();
  const message = messages[locale][id];
  return message;
}

export function formatMessage(id, defaultMessage) {
  const intlData = getIntl();
  const locale = intlData.locale;
  const nextData = {
    ...intlData,
    messages: intlData.messages[locale],
  };
  const { intl } = new IntlProvider(nextData, {}).getChildContext();
  return intl.formatMessage({ id, defaultMessage });
}

export function formatHTMLMessage(id, defaultMessage) {
  const { intl } = new IntlProvider(getIntl(), {}).getChildContext();
  return intl.formatHTMLMessage({ id, defaultMessage });
}

export function getTranslations(country = COUNTRY.toLowerCase(), locale) {
  let url = `/locales/${country}/${locale}.json`;
  if (REBRANDING && (country === 'ee' || country === 'lt' || country === 'lv')) {
    url = `/locales/${country}-creditea/${locale}.json`;
  }
  return {
    types: [
      actionTypes.GET_TRANSLATIONS,
      actionTypes.GET_TRANSLATIONS_SUCCESS,
      actionTypes.GET_TRANSLATIONS_FAIL,
    ],
    data: locale,
    promise: () => axios.create()({ url }),
  };
}
